import { OrganizationRole } from '@customTypes/clinician';

export const USER_ROLE_MAPPING: Record<OrganizationRole, string> = {
  [OrganizationRole.ADMIN]: 'Admin',
  [OrganizationRole.CLINICIAN]: 'Ordering Provider',
  [OrganizationRole.DELEGATE]: 'Organization Delegate',
};

export const NATERA_CAMPAIGN_CODE = 'NATERA';
export const CATALYST_CAMPAIGN_CODE = 'CATALYST';
export const NATERA_EMR_CAMPAIGN_CODE = 'NATERA_EMR';

export const SOLO_CAMPAIGN_CODES = [NATERA_CAMPAIGN_CODE, CATALYST_CAMPAIGN_CODE, NATERA_EMR_CAMPAIGN_CODE];
